module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai409-f7143971c5814fa4c634417a91cf9bf8.jpg";